import React, { useState } from "react";
import { GlobalState } from "./Helper/Context";
import Listen from "./Pages/Listen";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ErrorPage from "./Pages/ErrorPage";
import Header from "./Components/Header";
import Memorization from "./Pages/Memorization";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
function App() {
  const [state, setState] = useState({
    selectedReader: localStorage.selectedReader
      ? JSON.parse(localStorage.selectedReader)
      : {
          identifier: "ar.alafasy",
          name: "مشاري العفاسي",
          englishName: "Mishari Al-afasi",
        },
    selectedSurah: localStorage.selectedSurah
      ? JSON.parse(localStorage.selectedSurah)
      : {
          number: 1,
          name: "سُورَةُ ٱلْفَاتِحَةِ",
          englishName: "Al-Faatiha",
        },
    favSurah: localStorage.favSurah ? localStorage.favSurah : "",
    selectedMemorizationSurah: localStorage.selectedMemorizationSurah
      ? JSON.parse(localStorage.selectedMemorizationSurah)
      : {
          number: 1,
          name: "سُورَةُ ٱلْفَاتِحَةِ",
          englishName: "Al-Faatiha",
          numberOfAyahs: 7,
        },
    selectedVerse: localStorage.selectedVerse
      ? JSON.parse(localStorage.selectedVerse)
      : 1,
    selectedVerseReader: localStorage.selectedVerseReader
      ? JSON.parse(localStorage.selectedVerseReader)
      : {
          identifier: "ar.aymanswoaid",
          name: "أيمن سويد",
          englishName: "Ayman Sowaid",
        },
    TranslateVerse: localStorage.TranslateVerse
      ? JSON.parse(localStorage.TranslateVerse)
      : {
          identifier: "en.transliteration",
          langName: "الإنجليزية (تهجئة)",
          EnglishLangName: "English (transliteration)",
        },
    favVerse: localStorage.favVerse ? localStorage.favVerse : "",
    markVerse: localStorage.markVerse ? localStorage.markVerse : "",
    search: "",
    listMode: localStorage.listMode
      ? localStorage.listMode
      : window.innerWidth > 440
      ? "grid"
      : "list",
    langTo: localStorage.langTo,
  });
  const [showNew, setShowNew] = useState(localStorage.oldVist ? true : false);

  return (
    <GlobalState.Provider value={{ state, setState }}>
      <Router>
        <Home setShowNew={setShowNew} showNew={showNew} />
        <Header />
        <Routes>
          <Route
            path="/QuranApp"
            element={<Listen title="منصة ورتل القرآنية" />}
          />
          <Route
            path="/save"
            element={<Memorization title="منصة ورتل : التحفيظ" />}
          />
          <Route path="*" element={<ErrorPage langto={state.langTo} />} />
        </Routes>
        <Footer state={state} />
      </Router>
    </GlobalState.Provider>
  );
}

export default App;
